












































































































import Component from 'vue-class-component'
import Dialog from '@/shared/dialog/dialog'
import { Hooks } from '@/shared/interfaces/hooks'
import { ResetPasswordDialogInput } from '@/business/administration/components/reset-password/reset-password-dialog-input'
import { TypedForm } from '@/shared/forms/typed-form'
import {
  ResetPasswordForm,
  resetPasswordMapping,
} from '@/business/administration/components/reset-password/reset-password-form'
import { Prop } from 'vue-property-decorator'
import { Account, AdminResetPasswordRequest } from '@/api/generated'
import RespondecoTypedForm from '@/shared/components/respondeco-typed-form.vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import { generateRandomPassword } from '@/shared/utils/generate-random-password'
import UnifyFormInputAddon from '@/shared/components/unify/unify-form-input-addon.vue'
import ClipboardJS from 'clipboard'
import Vue from 'vue'
import { ClipboardMessages } from '@/shared/utils/clipboard-messages'
import RespondecoDefaultModalFooter from '@/shared/components/prompt-dialog/respondeco-default-modal-footer.vue'
import { Injector } from '@/config/dependency-injection'
import { AdministrationModule } from '@/business/administration/store/administration-module'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { RESET_PASSWORD } from '@/business/administration/store/types'
import { NotificationService } from '@/shared/services/notification-service'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import { TranslateService } from '@/shared/services/translate-service'

@Component({
  name: 'reset-password-dialog',
  components: {
    RespondecoValidationFeedback,
    RespondecoDefaultModalFooter,
    UnifyFormInputAddon,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    RespondecoTypedForm,
  },
  data() {
    return {
      form: undefined,
    }
  },
})
export default class ResetPasswordDialog extends Dialog<void>
  implements Hooks, ResetPasswordDialogInput {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly account!: Account

  public form!: TypedForm<AdminResetPasswordRequest, ResetPasswordForm>

  /**
   * Generated password suggestion
   */
  public suggestion: string = ''

  public suggestionTooltip: string = ClipboardMessages.Info

  private administrationModule = Injector.get(AdministrationModule)
  private loaderHelper = Injector.get(LoaderHelper)
  private notificationService = Injector.get(NotificationService)
  private translateService = Injector.get(TranslateService)

  private clipboard!: ClipboardJS

  public get loading(): boolean {
    return this.loaderHelper.isLoading(RESET_PASSWORD)
  }

  public beforeDestroy() {
    this.clipboard.destroy()
  }

  public mounted() {
    this.form = new TypedForm(resetPasswordMapping(), this)

    this.generateNewSuggestion()
  }

  public prepareClipboard(): void {
    this.clipboard = new ClipboardJS(this.$refs.copySuggestion as Element, {
      container: (this.$refs.container as Vue).$el,
    })

    this.clipboard
      .on('error', () => {
        this.suggestionTooltip = ClipboardMessages.Error
      })
      .on('success', () => {
        this.suggestionTooltip = ClipboardMessages.Success
      })
  }

  public resetSuggestionTooltip(): void {
    this.suggestionTooltip = ClipboardMessages.Info
  }

  public submit(): void {
    this.administrationModule
      .resetPassword({
        accountId: this.account.id,
        password: this.form.value.newPassword,
      })
      .then(() => {
        this.close()

        this.notificationService.showSuccess('administration.reset_password.success')
      })
      .catch(this.notificationService.errorHandler())
  }

  public validations() {
    return this.form.validations()
  }

  private generateNewSuggestion(): void {
    this.suggestion = generateRandomPassword(4, 2, 2, 2, 4)

    this.form.patch({
      newPassword: this.suggestion,
      passwordConfirmation: this.suggestion,
    })
  }
}
